/**
 * @generated SignedSource<<f4a4eb23f3d9ba1e27aed65c5878338e>>
 * @relayHash 0ef26395bdc8ca3dc88aaccf6b745222
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0ef26395bdc8ca3dc88aaccf6b745222

import { ConcreteRequest } from 'relay-runtime';
export type useRemoveAllAppointmentsMutationAndTheirDeEpisodeOfCareRelatedDataMutation$variables = Record<PropertyKey, never>;
export type useRemoveAllAppointmentsMutationAndTheirDeEpisodeOfCareRelatedDataMutation$data = {
  readonly de_removeAllEpisodeOfCareRelatedData: {
    readonly boolean: boolean | null;
  };
};
export type useRemoveAllAppointmentsMutationAndTheirDeEpisodeOfCareRelatedDataMutation = {
  response: useRemoveAllAppointmentsMutationAndTheirDeEpisodeOfCareRelatedDataMutation$data;
  variables: useRemoveAllAppointmentsMutationAndTheirDeEpisodeOfCareRelatedDataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "De_removeAllEpisodeOfCareRelatedDataPayload",
    "kind": "LinkedField",
    "name": "de_removeAllEpisodeOfCareRelatedData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useRemoveAllAppointmentsMutationAndTheirDeEpisodeOfCareRelatedDataMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useRemoveAllAppointmentsMutationAndTheirDeEpisodeOfCareRelatedDataMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "0ef26395bdc8ca3dc88aaccf6b745222",
    "metadata": {},
    "name": "useRemoveAllAppointmentsMutationAndTheirDeEpisodeOfCareRelatedDataMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "64479033acadf2c6edff30b6ac42ffb1";

export default node;
